import axios from 'axios'

const API_URL = window.APP_CONFIG.VITE_API_BASE_URL + '/api'

const instance = axios.create({
  baseURL: API_URL,
  withCredentials: true
})

export default instance
